export default __webpack_public_path__ + "static/media/mentor.1ac4ebd3.svg";